import { useState } from "react";
import { Link } from "react-router-dom";

const ZeroCommissionSection = ({ topFunds }) => {
  return (
    <section className="w-full border border-black-dark-200 rounded-3xl mt-16 p-8 rounded-2xl shadow-lg">
      {/* Top Section */}
      <div className="border border-black-dark-200 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-10">
        {/* Left Box */}
        <div className="border border-primary1 rounded-xl p-6 w-full md:w-1/4 text-center">
          <h2 className="text-primary1 text-5xl font-extrabold">₹0</h2>
          <p className="text-white mt-2 font-medium">Commission</p>
          <p className="text-gray-400 text-sm">On Mutual Funds Investments</p>
        </div>

        {/* Middle Text */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-3xl font-bold text-white">
            Grow your wealth with <span className="text-primary1">SIP</span>
          </h2>
          <p className="text-gray-300 mt-3">
            4,000+ Mutual Funds to choose from. Build long-term wealth with
            disciplined investing.
          </p>
        </div>

        {/* Right Input */}
        <div className="w-full md:w-1/4">
          <Link
            to="/open-account"
            className="block text-center mt-3 px-4 py-3 bg-primary1 hover:bg-primary-300 text-white rounded-xl transition"
          >
            START SIP
          </Link>
        </div>
      </div>

      {/* Table Section */}
      <div className="mt-10 border border-black-dark-200 p-6 rounded-2xl shadow-lg">
        <h3 className="text-2xl font-semibold text-white mb-10 mt-4">
          Top 5 Mutual Funds — <span className="text-primary1">TradeTact </span>
          Ranking
        </h3>

        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-gray-700">
              <th className="pb-3 text-gray-400">Scheme Name</th>
              <th className="pb-3 text-gray-400">3Y Return</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {topFunds.map((f, i) => (
              <tr key={i} className="border-b border-gray-700">
                <td className="py-5 text-gray-200">{f.name}</td>
                <td className="py-5 text-gray-300">{f.return}</td>
                {/* <td className="py-5">
                  <a
                    href="https://diy.sharekhan.com/app/Account/Register?grpcd=12688&type=pb&grpid=13118"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border border-primary1 text-primary1 px-4 py-2 rounded-lg hover:bg-primary1 hover:text-white transition"
                  >
                    Invest Now
                  </a>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ZeroCommissionSection;
